import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { PaginationFooter } from 'ui/paginationFooter';
import { TableHeader } from 'ui/tableHeader';
import { pxToRem } from 'utils/convert';

export const UsersTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const ScrollWrapper = styled.div`
  overflow-x: auto;
`;

export const StyledTableHeader = styled(TableHeader)`
  [data-test='header-cell'] {
    padding: ${spacing.base};
    &:first-child {
      padding-left: ${pxToRem(44)};
    }
  }
`;

export const StyledPaginationFooter = styled(PaginationFooter)`
  background-color: ${colors.backgroundPrimary};
  padding-bottom: ${spacing.base};
`;
